/**
 * Timing of the recent frames (for the dev harness and performance runs): the interval since
 * the previous frame, the engine's own script time and how long the frame kept the main
 * thread busy. Fixed ring buffers, nothing allocated per frame.
 */
import type { FrameSample } from './debug';

const HISTORY = 4096;

export class FrameStats {
  private readonly intervals = new Float64Array(HISTORY);
  private readonly work = new Float64Array(HISTORY);
  private readonly busy = new Float64Array(HISTORY);
  /** Frames recorded since the start. */
  count = 0;
  private sinceClear = 0;

  record(interval: number, work: number, busy: number): void {
    const slot = this.count % HISTORY;
    this.intervals[slot] = interval;
    this.work[slot] = work;
    this.busy[slot] = busy;
    this.count++;
    this.sinceClear++;
  }

  /** The recorded frames since the last clear(), oldest first (at most HISTORY). */
  samples(): FrameSample[] {
    const n = Math.min(this.sinceClear, HISTORY);
    const out: FrameSample[] = [];
    for (let k = n; k > 0; k--) {
      const slot = (this.count - k) % HISTORY;
      out.push({ interval: this.intervals[slot]!, work: this.work[slot]!, busy: this.busy[slot]! });
    }
    return out;
  }

  clear(): void {
    this.sinceClear = 0;
  }
}
